import { FORM_METHOD_TYPES } from "../../../../stateCommon/consts";
import { METHOD_TEMPLATES } from "../../../utils/consts";
export const init = options => {
  const {
    collection
  } = options;
  const isHttp = collection.type === 'http';
  const hasCount = !!collection.cgiInfo.count;
  const info = {
    args: [],
    tpl: METHOD_TEMPLATES.list.init,
    type: FORM_METHOD_TYPES.init,
    params: {
      assign: [{
        key: 'page',
        code: '1'
      }, {
        key: 'size',
        code: '20'
      }, {
        key: 'filter',
        code: '[]'
      }, {
        key: 'sort',
        code: '[]'
      }],
      invoke: [{
        args: [],
        method: 'list',
        enabled: true
      }]
    }
  };
  if (isHttp) {
    info.params.invoke.push({
      args: [],
      method: 'count',
      enabled: hasCount
    });
  }
  return info;
};
//# sourceMappingURL=init.js.map
